/* tslint:disable */
/* eslint-disable */

/**
 * deliveryProviderPortal location-suggestions-delivery api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */

import { ApiResponse,  GeneratedApiClient, GeneratedHttpClientConstraints, RequestOptionsConstraint, HttpMethod, AuthStrategy, ShardingStrategy } from "../runtime";

import type {
    GetPlaceDetailsRequest,
    PublicGetPlaceDetails200Response,
    PublicSuggestProviderLocations200Response,
    StandardRequest,
} from '../models/index';

export interface HttpClientConstraints {
    Auth: AuthStrategy.NONE;
    Sharding: ShardingStrategy.NONE;
    StandardRequest: StandardRequest;
}

export interface PublicSuggestProviderLocationsRequest {
    session_id: string;
    version: string;
    gps_lat?: number;
    gps_lng?: number;
    language: string;
    lat?: number;
    lng?: number;
    count?: number;
    search_string?: string;
}


class ApiClientClass<THttpClientConstraints extends GeneratedHttpClientConstraints = HttpClientConstraints, TRequestOptions extends RequestOptionsConstraint = never> extends GeneratedApiClient<THttpClientConstraints, TRequestOptions> {
        public publicGetPlaceDetails = async (body: GetPlaceDetailsRequest, opts?: TRequestOptions): Promise<ApiResponse<PublicGetPlaceDetails200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<PublicGetPlaceDetails200Response>>({
                path: '/deliveryProviderPortal/public/getPlaceDetails',
                service_id: 'location-suggestions-delivery',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: false },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public publicSuggestProviderLocations = async (query: PublicSuggestProviderLocationsRequest, opts?: TRequestOptions): Promise<ApiResponse<PublicSuggestProviderLocations200Response>>  => {
            return this.httpClient.sendRequest<ApiResponse<PublicSuggestProviderLocations200Response>>({
                path: '/deliveryProviderPortal/public/suggestProviderLocations',
                service_id: 'location-suggestions-delivery',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: false },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                query,
            }, opts);
        }
}
// Split class actual prototype and type
export const ApiClient = ApiClientClass;
/**
 * When you use ApiClient class as a type it would include private / protected properties which leads
 * to a situation where 2 sources of the ApiClient are not equal.
 *
 * This situation can happen for example when a library depends on the whole ApiClient and consumer wants to pass
 * in its own ApiClient. That would lead to an error
 *
 * TS2345: Argument of type 'ApiClient<HttpClientConstraints, HttpRequestOpts>' is not assignable to parameter of type 'ApiClient<HttpClientConstraints, never>'.
 *  Property 'apiClientOptions' is protected but type 'GeneratedApiClient<THttpClientConstraints, TRequestOptions>' is not a class derived from 'GeneratedApiClient<THttpClientConstraints, TRequestOptions>'.
 */
export type ApiClient<THttpClientConstraints extends GeneratedHttpClientConstraints = HttpClientConstraints, TRequestOptions extends RequestOptionsConstraint = never> = {
    [Key in keyof ApiClientClass<THttpClientConstraints, TRequestOptions>]: ApiClientClass<THttpClientConstraints, TRequestOptions>[Key];
};